import {
  DISPLAY_NAME_FORBIDDEN,
  DISPLAY_NAME_JOINERS_ONLY,
  MAX_DISPLAY_NAME_LENGTH,
  MAX_PASSWORD_LENGTH,
  MIN_DISPLAY_NAME_LENGTH,
  MIN_PASSWORD_LENGTH,
} from '@sigora/domain';

/**
 * What is wrong with a display name as typed, or null when the server would take it. It checks the
 * server's own bounds and display-name rule before sending, so a problem is answered beside the
 * field rather than by a round trip; the server stays the authority, and anything this let through
 * would come back as the same refusal.
 */
export const displayNameProblem = (name: string): string | null => {
  const trimmed = name.trim();

  if (trimmed.length < MIN_DISPLAY_NAME_LENGTH) {
    return 'Enter the name to show on your work.';
  }

  if (trimmed.length > MAX_DISPLAY_NAME_LENGTH) {
    return `Use at most ${MAX_DISPLAY_NAME_LENGTH} characters.`;
  }

  if (DISPLAY_NAME_FORBIDDEN.test(trimmed) || DISPLAY_NAME_JOINERS_ONLY.test(trimmed)) {
    return 'Use only visible characters.';
  }

  return null;
};

/** What is wrong with a new password, or null when the server would take it. */
export const passwordProblem = (password: string): string | null => {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Use at least ${MIN_PASSWORD_LENGTH} characters.`;
  }

  if (password.length > MAX_PASSWORD_LENGTH) {
    return `Use at most ${MAX_PASSWORD_LENGTH} characters.`;
  }

  return null;
};
